<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		checked?: boolean;
		onChange?: (checked: boolean) => void;
	}

	let { checked = $bindable(false), onChange }: Props = $props();
</script>

<div
	class="p-4 text-body text-md neutral-strongest bg-electric-weakest rd-2 border-1 border-solid border-electric-weak"
>
	<Switch
		id="EVtoggle"
		text={m.itinerary__options__ev_toggle()}
		uncheckedTrackClass="bg-electric-weak"
		bind:checked
		onchange={() => {
			onChange?.(checked);
		}}
	/>
</div>
